<template>
  <!-- cookie acceptance screen when logging into the system, it must be accepted every time when logging in -->
  <div class="div-main" >
    <div class="img-align">
      <img
        :src="'static/img/cookies.png'"
        style="width: 200px; text-align: center"
        alt="logo-cookie"
      />
    </div>

    <ul>
      <li>
        O PORTAL DE BOLETOS usa "Cookies Operacionais de Sessão" para o
        funcionamento do sistema, que podem armazenar seus dados pessoais
        indiretamente.
      </li>
      <br />
      <li>
        Conforme detalhado na "Política de Privacidade do PORTAL DE
        BOLETOS" e de acordo com o Art. 5 da LGPD (Lei 13.709/2018),
        solicitamos seu CONSENTIMENTO para prosseguir.
      </li>
      <br />
      <li>
        A não concordância com essa política implicará na impossibilidade
        de uso dessa aplicação pelo fato desta ter sua operacionalidade
        prejudicada
      </li>
    </ul>

  </div>
</template>
<script>

export default {
  name: "CookiesPolicy",

  data() {
    return {

    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.img-align {
  display: flex;
  justify-content: center;
}

.div-main {
  background-color: white;
  font-family: sans-serif !important;
  font-size: 14px;
  height: 100vh;
}

label {
  margin-left: 40px;
  margin-left: 35px;
}


@media only screen and (max-width: 960px) {
  /* styles for browsers larger than 960px; */

  label {
    margin-left: 25px;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/accepts/CookiesPolicy.vue